import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
var numeral = require('numeral');

 
class CalculatorModal extends Component {
 
componentDidMount(){
    this._isMounted = true;
     
    }
       
componentWillUnmount(){
  this._isMounted = false;
}

constructor(props,context){
    super(props)
    this.state = {

        summaryModalShow: false,
        hide:this.props.onHide,
        loading:true,
        amount:0,
        percent:0,
        currencyType:this.props.currency.slice(0,3),
        
        
    }

  }

  //amountChange
  amountChange = (event) => {		
    let amount = event.target.value;
    this.setState({
        amount: amount
    },()=>console.log());
    
}

 //amountChange
 percentChange = (event) => {		
    let percent = event.target.value;
    this.setState({
        percent: percent
    },()=>console.log());
    
}

    changeUSD = (event) =>{
        let currency = event.target.value;
        this.setState({currencyType:currency},()=>console.log())
        
    }
    
  
  

    render(){
      
        let currencyType = <h5>{this.state.amount} {this.props.currency.slice(0,3)} = {numeral(this.state.amount / this.props.coinPrice).format('0,0.00000000')} {this.props.coinName}</h5>
        let profitType =  <h5>{this.state.amount} {this.state.currencyType} + {this.state.percent}% =  {(parseInt(this.state.amount) + (this.state.amount*(this.state.percent / 100)))} {this.state.currencyType}: {numeral(this.state.amount*(this.state.percent / 100)).format('0,0.00')} {this.state.currencyType} Profit </h5>

        if(this.state.currencyType == this.props.coinName){
            currencyType = <h5>{this.state.amount} {this.props.coinName} = {numeral(this.state.amount * this.props.coinPrice).format('0,0.0000')} {this.props.currency.slice(0,3)}</h5>
        }

        if(this.state.currencyType == this.props.coinName){
            profitType = <h5>{this.state.amount} {this.state.currencyType} + {this.state.percent}% =  {(parseInt(this.state.amount) + (this.state.amount*(this.state.percent / 100)))} {this.state.currencyType}: {numeral(this.state.amount*(this.state.percent / 100)).format('0,0.00')} {this.state.currencyType} Profit </h5>
        }
      
       
    return( 
      
      <Modal
        {...this.props}
        size="md"
        height="200px"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        
      <Modal.Header className="modalpie" closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        <div className="banana3">Calculator</div>
      </Modal.Title>
      </Modal.Header> 
        
      <Modal.Body> 
      <h5>1 {this.props.coinName} = {this.props.coinPrice} {this.props.currency.slice(0,3)} </h5>
        {currencyType}
        {profitType}

      <div>
			<div>
					<div className="input-group mt-5">
					<div className="input-group-prepend">
                    <select onChange={this.changeUSD}  className="input-group-text">
						<option value={this.props.currency.slice(0,3)} key="1">{this.props.currency.slice(0,3) + " Amount"}</option>
                        <option value={this.props.coinName} key="2">{this.props.coinName + " Amount"}</option>
                    </select>   
					</div>
					<input type="number" min="1" className={"form-control "} id="amount" title={"Amount Needed"} autoComplete="off" onChange={this.amountChange}/>
          
          </div>
					<small className="form-text text-muted mb-3 ">Amount to calculate</small>	
		    </div>
            <div>
					<div className="input-group mt-2">
					<div className="input-group-prepend">                
						<span className="input-group-text">% Profit</span>
					</div>
					<input type="number" min="1" className={"form-control "} id="amount" title={"% Profit"} autoComplete="off" onChange={this.percentChange}/>
          
          </div>
					<small className="form-text text-muted mb-3 ">Calculate Profit %</small>	
		    </div>
		</div>
        
        <button  className="cancel" title="Cancel" onClick={this.props.onHide}>Cancel</button>
      </Modal.Body>
            
      

      </Modal>
      )
    }

}

export default CalculatorModal;